const genders = ['Feminino', 'Masculino',];

export const validGender = (data) => genders.includes(data);
